// extracted by mini-css-extract-plugin
export default {"mCard":"DE-z","image":"EE-z","imageNoBackground":"FE-z","imageHasCategory":"GE-z","fullWidth":"HE-z"};